__turbopack_context__.v({
  "bookTitle": "work-peek-inside-module-scss-module__35Vl4W__bookTitle",
  "chapter": "work-peek-inside-module-scss-module__35Vl4W__chapter",
  "content": "work-peek-inside-module-scss-module__35Vl4W__content",
  "coverButton": "work-peek-inside-module-scss-module__35Vl4W__coverButton",
  "modal": "work-peek-inside-module-scss-module__35Vl4W__modal",
  "otherEditionNotice": "work-peek-inside-module-scss-module__35Vl4W__otherEditionNotice",
  "peekButton": "work-peek-inside-module-scss-module__35Vl4W__peekButton",
  "peekImage": "work-peek-inside-module-scss-module__35Vl4W__peekImage",
  "root": "work-peek-inside-module-scss-module__35Vl4W__root",
  "status": "work-peek-inside-module-scss-module__35Vl4W__status",
  "u-animation-bounce": "work-peek-inside-module-scss-module__35Vl4W__u-animation-bounce",
});
